import http from '../../http'

export async function createNotifications(payload) {
  return http.post('/notification', payload)
}

export async function getNotifications({ page, take }) {
  return http.get('/Receiver', {
    params: {
      page,
      take
    }
  })
}

export async function editNotifications({ id, isRead }) {
  return http.put('/Receiver', {
    id,
    isRead
  })
}

export async function removeNotifications(id) {
  return http.delete('/Receiver', {
    data: {
      id
    }
  })
}

export async function findNotificationsByUsers() {
  return http.get('/notification/get-sent-by-user', {
    headers: {
      accept: 'text/plain;charset=UTF-8'
    }
  })
}

export async function disableNotificationByUsers(id) {
  return http.patch('/notification/disable-notification', {
    id
  })
}

export async function deactivateRecurrence(id) {
  return http.patch('notification/disable-recurrence', {
    ruleId: id
  })
}

export function getRecurrenceDetails(id) {
  return http.get(`notification/get-recurrence-details/${id}`)
}
